import '../../../styles/Loading.css';
import { LoadingProps } from './Loading.types';

export default ({ isFullscreen = true }: LoadingProps) => {
  if (isFullscreen)
    return (
      <div className="loader-fullscreen" data-testid="loader-fullscreen">
        <div className="loader" data-testid="loader" />
      </div>
    );
  return <div className="loader" data-testid="loader" />;
};
